import React from 'react';

const NotFoundPage = () => {
	return (
		<section>
			<div className="wrapper" style={{ textAlign: "center" }}>
				<h2 style={{ marginBottom: "0" }}>I have gone astray like a lost sheep...</h2>
				<h3 style={{ margin: "0 0 1rem", border: "none" }}>Ps. 119:176</h3>

				<p>
					Sorry, but the page you&rsquo;re looking for <span className="no-wrap">can&rsquo;t be found.</span>
				</p>
			</div>
		</section>
	);
};

export default NotFoundPage;